// extracted by mini-css-extract-plugin
export default {"uploadImageSection":"UploadImage_uploadImageSection__O-zAz","uploadImageTitle":"UploadImage_uploadImageTitle__vp5M+","uploadImageImage":"UploadImage_uploadImageImage__uLXe-"};